import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../../shared/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { PageAdminComponent } from './page-admin.component';
import { AddressSearchComponent } from './header/address-search/address-search.component';
import { NotificationsComponent } from './header/notifications/notifications.component';
import { UserComponent } from './header/user/user.component';
import { UserNewPasswordComponent } from './header/user/user-new-password/user-new-password.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    SidemenuComponent,
    PageAdminComponent,
    AddressSearchComponent,
    NotificationsComponent,
    UserComponent,
    UserNewPasswordComponent
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    SidemenuComponent,
    PageAdminComponent,
  ],
})
export class PageAdminModule {
  static forRoot(): ModuleWithProviders<PageAdminModule> {
    return {
      ngModule: PageAdminModule,
      providers: SharedModule.forRoot().providers,
    };
  }
}
